export default __webpack_public_path__ + "static/media/fhm-site.e9bb01c6.webp";